import * as React from 'react';
import { cn } from '../lib/utils';
import { fieldClassName, useFieldControl } from '../lib/field';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(fieldClassName, 'flex h-9 px-3 py-1.5 file:mr-3 file:border-0 file:bg-transparent file:text-sm file:font-medium', className)}
      {...useFieldControl(props)}
    />
  )
);

Input.displayName = 'Input';
